module.exports = __webpack_public_path__ + "img/BAU_Partners_12.a8baec05.jpg";